"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cart = _interopRequireDefault(require("@sfly/uig-svg-icon/account/cart"));

var _cart_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/account/cart_selected"));

require("./style.css");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var CartCountIcon = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CartCountIcon, _React$Component);

  var _super = _createSuper2(CartCountIcon);

  function CartCountIcon() {
    (0, _classCallCheck2.default)(this, CartCountIcon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CartCountIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          count = _this$props.count,
          size = _this$props.size,
          isHighlighted = _this$props.isHighlighted,
          textLength = _this$props.textLength;
      var circlePos = {
        x: '73',
        y: '27'
      };
      return _react.default.createElement("div", {
        className: "uig-cart-count-icon",
        style: {
          width: size,
          height: size
        }
      }, _react.default.createElement("svg", {
        viewBox: "0 0 100 100"
      }, isHighlighted ? _react.default.createElement(_cart_selected.default, {
        x: "0",
        y: "20",
        width: "70",
        height: "70"
      }) : _react.default.createElement(_cart.default, {
        x: "0",
        y: "20",
        width: "70",
        height: "70"
      }), count > 0 && _react.default.createElement("g", null, _react.default.createElement("circle", {
        cx: circlePos.x,
        cy: circlePos.y,
        r: "30",
        fill: "white"
      }), _react.default.createElement("circle", {
        className: "orange",
        cx: circlePos.x,
        cy: circlePos.y,
        r: "25"
      }), _react.default.createElement("text", {
        x: circlePos.x,
        y: "38",
        textLength: textLength || '35',
        textAnchor: "middle",
        fontSize: "32"
      }, count > 9 ? '9+' : count))));
    }
  }]);
  return CartCountIcon;
}(_react.default.Component);

exports.default = CartCountIcon;
CartCountIcon.propTypes = {
  count: _propTypes.default.number,
  size: _propTypes.default.string,
  textLength: _propTypes.default.string,
  isHighlighted: _propTypes.default.bool
};
CartCountIcon.defaultProps = {
  count: 0,
  size: '22px',
  textLength: '35',
  isHighlighted: false
};